import {Guid} from '../../../store/model/guid';
import {isMandatory, Item} from '@ael/core-api';
import * as Immutable from 'immutable';
import {List} from 'immutable';

export class MandatoryItemsStore {
  private _items: Immutable.Set<Guid>;

  constructor() {
    this._items = Immutable.Set<Guid>();
  }

  populateFromItems(allItems: List<Item>) {
    this._items = allItems
      .filter((item: Item) => {
        return isMandatory(item);
      })
      .map((item: Item) => item.id)
      .toSet();
  }

  toJS() {
    return this._items;
  }

  isMandatory(itemId: Guid) {
    return this._items.contains(itemId);
  }
}
